<template>
  <v-dialog
    v-model="recursoDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="recursoDialog= false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          Avaliação de recurso
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-card>
            <v-card-text v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR">
              <v-layout
                align-space-between
                justify-space-between
                row
              >
                <v-flex
                  v-if="!formulario.avaliador"
                  sm11
                >
                  <v-btn
                    v-if="formulario.st_parecer == null"
                    round
                    color="secondary"
                    @click="abrirDialogoSelecaoAvaliador"
                  >
                    <v-icon left>
                      add
                    </v-icon>
                    Incluir Avaliador
                  </v-btn>
                </v-flex>

                <v-flex
                  v-else
                  sm11
                >
                  <v-layout>
                    <v-text-field
                      v-model="formulario.avaliador.no_nome"
                      style="max-width: 320px; margin-right: 50px;"
                      label="Nome do Avaliador"
                      append-icon="perm_identity"
                      disabled
                    />
                    <v-text-field
                      v-model="formulario.avaliador.nu_cpf"
                      style="max-width: 240px;"
                      label="CPF do Avaliador"
                      append-icon="person"
                      mask="###.###.###-##"
                      disabled
                    />
                  </v-layout>
                  <v-btn
                    v-if="!formulario.st_parecer"
                    round
                    color="secondary"
                    @click="abrirDialogoSelecaoAvaliador"
                  >
                    <v-icon
                      small
                      left
                    >
                      edit
                    </v-icon>
                    Alterar Avaliador
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-text>
              <v-form
                ref="form_recurso"
                v-model="valid"
                lazy-validation
              >
                <v-layout
                  class="mt-1"
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm6
                    lg12
                  >
                    <v-btn
                      max-width="20px"
                      round
                      color="gray"
                      small
                      @click="abrirDialogoHistorico"
                    >
                      <v-icon
                        left
                        small
                      >
                        history
                      </v-icon>
                      Histórico
                    </v-btn>
                    <v-btn
                      v-if="this.formulario.ds_parecer"
                      max-width="20px"
                      round
                      color="gray"
                      small
                      @click="createRecursoPdf"
                    >
                      <v-icon
                        left
                        small
                      >
                        picture_as_pdf
                      </v-icon>
                      Gerar PDF
                    </v-btn>
                  </v-flex>


                  <v-flex
                    xs12
                    sm6
                  >
                    <v-radio-group
                      :value="formulario.co_fase"
                      row
                      disabled
                    >
                      <v-radio
                        label="Conselho de cultura"
                        value="4"
                      />
                      <v-radio
                        label="Organização ou entidade cultural"
                        value="5"
                      />
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md4
                  >
                    <v-btn
                      round
                      color="secondary"
                      small
                      @click="abrirDialogoEntidade"
                    >
                      <v-icon left>
                        subject
                      </v-icon>
                      Ver Detalhes da Inscricao
                    </v-btn>
                  </v-flex>
                </v-layout>


                <v-layout
                  wrap
                  align-center
                  class="mt-1"
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.nu_cnpj"
                      label="CNPJ"
                      append-icon="people"
                      placeholder="99.999.999/9999-99"
                      mask="##.###.###/####-##"
                      required
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.no_razao_social"
                      label="Razão social"
                      append-icon="people_outline"
                      required
                      style="margin-left: 20px"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  wrap
                  align-center
                  class="mt-1"
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.nu_cpf"
                      label="CPF do representante"
                      append-icon="person"
                      mask="###.###.###-##"
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.no_representante"
                      label="Nome do representante"
                      append-icon="perm_identity"
                      style="margin-left: 20px"
                      disabled
                    />
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  align-center
                  class="mt-1"
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.ds_email"
                      data-vv-name="email"
                      label="E-mail do representante"
                      append-icon="mail"
                      placeholder="email@exemplo.com"
                      maxlength="100"
                      required
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.nu_telefone"
                      label="Celular do representante"
                      append-icon="phone"
                      placeholder="(99) 99999-9999"
                      mask="(##) #####-####"
                      required
                      style="margin-left: 20px"
                      disabled
                    />
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  align-center
                  class="mt-1"
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      :value="formulario.dh_cadastro | formatDate"
                      label="Data de Solicitação do Recurso"
                      append-icon="event"
                      required
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    v-if="formulario.arquivos && formulario.arquivos.length"
                    sm12
                  >
                    <v-btn
                      color="blue-grey"
                      class="white--text text-capitalize"
                      outline
                      @click="downloadArquivo(formulario.arquivos.find(a => a.tp_arquivo == 'recurso_inscricao').co_arquivo)"
                    >
                      Download anexo Recurso
                      <v-icon
                        right
                        dark
                      >
                        cloud_download
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>


                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                  >
                    <div class="ma-4 text-justify subheading grey--text">
                      <b>Descrição do recurso:</b>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                    class="ma-3"
                  >
                    <v-textarea
                      :value="formulario.ds_recurso"
                      name="input-7-1"
                      box
                      solo
                      label="Descrição do recurso"
                      auto-grow
                      :placeholder="'Digite seu recurso aqui.'"
                      :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                      :counter="3000"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-divider />

                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                    class="ma-3"
                  >
                    <div class="ma-4 text-justify subheading grey--text">
                      <b>Parecer:</b>
                    </div>
                    <v-textarea
                      v-model="formulario.ds_parecer"
                      name="input-7-1"
                      box
                      solo
                      label="Parecer do recurso"
                      auto-grow
                      :placeholder="'Digite seu recurso aqui.'"
                      :counter="3000"
                      :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                      required
                      :disabled="formulario.dh_parecer !== null"
                    />
                  </v-flex>
                </v-layout>
                <v-layout v-if="formulario.arquivos && !formulario.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao') && !formulario.st_parecer_validado && showCardAnexoParecer">
                  <v-flex
                    xs12
                    lg2
                    md4
                    sm4
                  >
                    <v-card class="mt-4 ml-4">
                      <v-card-text class="recurso-inscricao-file">
                        <file
                          v-model="parecer_recurso_inscricao"
                          max-file-size="100MB"
                          max-files="1"
                          label-idle="Clique aqui para anexar um arquivo (PDF ou JPEG com limite de 100 MB)"
                          :accepted-file-types="acceptedFileTypes"
                          :readonly="formulario.st_parecer_validado"
                          :disabled="formulario.st_parecer_validado"
                          @input="fileAdded()"
                        />
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="formulario.arquivos && formulario.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao') && !isLoadingRequest"
                  align-space-between
                  row
                >
                  <v-flex
                    xs12
                    lg3
                    md6
                    sm6
                  >
                    <v-btn
                      color="blue-grey"
                      class="white--text text-capitalize"
                      outline
                      @click="downloadArquivo(formulario.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao').co_arquivo)"
                    >
                      Download anexo Parecer
                      <v-icon
                        right
                        dark
                      >
                        cloud_download
                      </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex
                    v-if="!formulario.st_parecer_validado && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"
                    xs12
                    lg3
                    md6
                    sm6
                  >
                    <v-btn
                      color="blue-grey"
                      class="white--text text-capitalize"
                      outline
                      @click="excluirAnexoParecer(formulario.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao').co_arquivo)"
                    >
                      Excluir anexo Parecer
                      <v-icon
                        right
                        dark
                      >
                        delete
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout v-else-if="isLoadingRequest">
                  <v-progress-linear indeterminate />
                </v-layout>
                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                    class="ma-3"
                  >
                    <v-radio-group
                      v-model="formulario.st_parecer"
                      :rules="[rules.required]"
                      :disabled="formulario.dh_parecer !== null"
                    >
                      <template v-slot:label>
                        <div><strong>Avaliação</strong></div>
                      </template>
                      <v-radio
                        value="1"
                        color="success"
                      >
                        <template v-slot:label>
                          <div><strong class="success--text">Recurso Deferido</strong></div>
                        </template>
                      </v-radio>
                      <v-radio
                        value="0"
                        color="error"
                      >
                        <template v-slot:label>
                          <div><strong class="error--text">Recurso Indeferido</strong></div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout
                  v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR && formulario.ds_parecer_justificativa"
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                  >
                    <div class="ma-4 text-justify subheading grey--text">
                      <b>Justificativa da edição do recurso:</b>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR && formulario.ds_parecer_justificativa"
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                    class="ma-3"
                  >
                    <v-textarea
                      v-model="formulario.ds_parecer_justificativa"
                      name="input-7-1"
                      box
                      solo
                      label="Justificativa da edição"
                      auto-grow
                      :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                      :counter="3000"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          @click="recursoDialog= false"
        >
          <v-icon left>
            undo
          </v-icon>
          Voltar
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="!valid || loading || formulario.dh_parecer !== null"
          color="primary"
          @click.native="abrirDialogo"
        >
          <v-icon left>
            send
          </v-icon>
          Avaliar
        </v-btn>
        <v-btn
          v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR && formulario.dh_parecer !== null && !formulario.st_parecer_validado"
          :loading="loading"
          color="primary"
          @click.native="abrirDialogoEditar"
        >
          <v-icon left>
            edit
          </v-icon>
          Editar parecer
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="modalConfirmacao"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="loading"
        @dialog-response="respostaDialog"
      />
    </v-layout>

    <v-layout justify-center>
      <selecao-avaliador-dialog
        v-model="modalSelecaoAvaliador"
        :props-avaliador="selecaoAvaliador"
        :is-loading="isLoadingSelecao"
        @alterar="alterarAvaliador"
      />
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="modalDialogoEntidade"
        scrollable
        max-width="750"
      >
        <v-card>
          <v-toolbar
            dark
            color="secondary"
          >
            <v-btn
              icon
              dark
              @click="modalDialogoEntidade = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
              Detalhes da Inscrição
              <v-chip
                v-if="formulario.co_fase == 5"
                color="grey"
                style="margin-left:250px"
              >
                Pontuação inicial:&nbsp;
                <b v-if="isLoadingEntidade">
                  <v-progress-circular
                    :width="1"
                    :size="10"
                    indeterminate
                  />
                </b>
                <b v-else>
                  {{ organizacao.pontuacao }}
                </b>
              </v-chip>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="isLoadingEntidade">
            <v-progress-linear
              indeterminate
              height="5"
            />
          </v-card-text>
          <v-card-text v-else>
            <conselho-detalhes-inscricao-visualizacao
              v-if="formulario.co_fase == 4"
            />
            <organizacao-detalhes-inscricao-visualizacao
              v-if="formulario.co_fase == 5"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout justify-center>
      <historico-avaliacao-dialog
        v-model="modalDialogoHistorico"
        :recurso-inscricao="formulario.co_recurso_inscricao"
      />
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="modalDialogoEditar"
        max-width="800"
      >
        <v-card>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <div class="ma-4 text-justify subheading grey--text">
                <b>Parecer:</b>
              </div>
              <v-textarea
                v-model="formularioEditado.ds_parecer"
                name="input-7-1"
                box
                solo
                label="Parecer do recurso"
                auto-grow
                :placeholder="'Digite seu recurso aqui.'"
                :counter="3000"
                :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <div class="ma-4 text-justify subheading grey--text">
                <b>Justificativa da edição:</b>
              </div>
              <v-textarea
                v-model="formularioEditado.ds_parecer_justificativa"
                name="input-7-1"
                box
                solo
                label="Justificativa da edição do recurso"
                auto-grow
                :placeholder="'Digite sua justificativa de edição do recurso aqui.'"
                :counter="3000"
                :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <v-radio-group
                v-model="formularioEditado.st_parecer"
                :rules="[rules.required]"
              >
                <template v-slot:label>
                  <div><strong>Avaliação</strong></div>
                </template>
                <v-radio
                  value="1"
                  color="success"
                >
                  <template v-slot:label>
                    <div><strong class="success--text">Recurso Deferido</strong></div>
                  </template>
                </v-radio>
                <v-radio
                  value="0"
                  color="error"
                >
                  <template v-slot:label>
                    <div><strong class="error--text">Recurso Indeferido</strong></div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-card-actions v-if="!isLoadingSelecao">
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              flat
              @click="fecharDialogoEditar"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              flat
              :disabled="!formularioEditado.ds_parecer_justificativa || formularioEditado.st_parecer == null"
              @click="editar"
            >
              Editar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { eventHub } from '@/event';
import moment from 'moment';
import JsPdf from 'jspdf';
import File from '@/core/components/upload/File';
import codigosPerfil from '../../conta/utils/codigosPerfil';
import codigosFase from '../../fase/utils/codigosFase';

import HistoricoAvaliacaoDialog from './components/HistoricoAvaliacaoDialog';
import DialogConfirmacao from '../../shared/components/DialogConfirmacao';
import SelecaoAvaliadorDialog from './components/SelecaoAvaliadorDialog';
import ConselhoDetalhesInscricaoVisualizacao from '../../conselho/views/ConselhoDetalhesInscricaoVisualizacao';
import OrganizacaoDetalhesInscricaoVisualizacao from '../../organizacao/views/OrganizacaoDetalhesInscricaoVisualizacao';

export default {
  name: 'ListaRecursosDialog',
  components: {
    File,
    DialogConfirmacao,
    SelecaoAvaliadorDialog,
    HistoricoAvaliacaoDialog,
    ConselhoDetalhesInscricaoVisualizacao,
    OrganizacaoDetalhesInscricaoVisualizacao,
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    usuario: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      codigosPerfil,
      codigosFase,
      confirmacaoDados: false,
      modalConfirmacao: false,
      modalSelecaoAvaliador: false,
      modalDialogoEntidade: false,
      modalDialogoHistorico: false,
      modalDialogoEditar: false,
      co_perfil: String(),
      nomeFormularioError: String(),
      recursoDialog: false,
      loading: false,
      isLoadingRequest: false,
      isLoadingHistorico: false,
      isLoadingSelecao: false,
      isLoadingEntidade: false,
      valid: false,
      perfilPodeSerAlterado: false,
      showCardAnexoParecer: false,
      selecaoAvaliador: {
        co_usuario: 0,
        co_objeto: 0,
      },
      formularioEditado: {},
      formulario: {},
      parecer_recurso_inscricao: {},
      acceptedFileTypes: [
        'image/jpeg',
        'application/pdf',
      ],
      fileLoaded: false,
      rules: {
        required: value => !!value || 'Este campo é obrigatório',
        minCaracter: value => value.length >= 8 || 'Mínimo 8 caracteres',
        tamanhoMaximoCaracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
      },
    };
  },
  computed: {
    ...mapGetters({
      perfil: 'conta/perfil',
      perfis: 'conta/perfis',
      avaliadores: 'conta/usuarios',
      perfisInscricao: 'conta/perfisInscricao',
      conselho: 'conselho/conselho',
      organizacao: 'organizacao/organizacao',
    }),
  },
  watch: {
    value(alternarDialogRecurso) {
      this.recursoDialog = alternarDialogRecurso;
    },
    recursoDialog(alternarDialogRecurso) {
      this.$emit('input', alternarDialogRecurso);
      this.formulario = Object.assign({});
      this.$refs.form_recurso.reset();
      if (alternarDialogRecurso) {
        this.formulario = Object.assign(this.formulario, this.usuario);
        this.selecaoAvaliador = {
          co_usuario: this.formulario.avaliador ? this.formulario.avaliador.co_usuario : 0,
          co_objeto: this.formulario.co_recurso_inscricao,
        };
        if (this.formulario.co_fase == codigosFase.RECURSO_INSCRICOES_CONSELHO) {
          this.isLoadingEntidade = true;
          this.obterConselhoPorRepresentante(this.formulario.co_representante);
        } else {
          this.isLoadingEntidade = true;
          this.obterOrganizacaoPorRepresentante(this.formulario.co_representante);
        }

        if (this.perfil.co_perfil == codigosPerfil.CODIGO_AVALIADOR && !this.formulario.st_parecer) {
          this.showCardAnexoParecer = true;
        }

        if (this.perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR && !this.formulario.st_parecer_validado) {
          this.showCardAnexoParecer = true;
        }
      }
    },
    usuario(usuario) {
      this.formulario = Object.assign(this.formulario, usuario);
    },
    organizacao() {
      this.isLoadingEntidade = false;
    },
    conselho() {
      this.isLoadingEntidade = false;
    },
  },
  methods: {
    ...mapActions({
      buscarPerfisAlteracao: 'conta/buscarPerfisAlteracao',
      tratarUsuarioLogado: 'conta/tratarUsuarioLogado',
      avaliarRecursoInscricao: 'recurso/avaliarRecursoInscricao',
      downloadArquivo: 'shared/downloadArquivo',
      atualizarAvaliador: 'recurso/atualizarAvaliador',
      obterHistoricoAvaliacao: 'recurso/obterHistoricoAvaliacao',
      excluirArquivo: 'recurso/excluirArquivo',
      obterOrganizacaoPorRepresentante: 'organizacao/obterOrganizacaoPorRepresentante',
      obterConselhoPorRepresentante: 'conselho/obterConselhoPorRepresentante',
    }),
    fileAdded(value) {
      this.fileLoaded = !this.fileLoaded;
    },
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.salvar();
      } else {
        this.fecharDialogo();
      }
    },
    excluirAnexoParecer(co_arquivo_parecer) {
      this.isLoadingRequest = true;
      const co_recurso = this.formulario.co_recurso_inscricao;
      this.excluirArquivo({ coRecursoInscricao: co_recurso, coArquivo: co_arquivo_parecer });
      this.formulario.arquivos.splice(a => a.tp_arquivo != 'parecer_recurso_inscricao');
      setTimeout(() => {
        this.isLoadingRequest = false;
      }, 3000);


      if (this.perfil.co_perfil != codigosPerfil.CODIGO_ADMINISTRADOR) {
        this.showCardAnexoParecer = false;
      }
    },
    validarAnexos() {
      this.formulario.anexos = [];
      const anexos = [
        'parecer_recurso_inscricao',
      ];
      anexos.forEach((nomeAnexo) => {
        if (
          Object.values(this[nomeAnexo]).length === 0) {
          return;
        }

        this.formulario.anexos.push({
          tp_arquivo: nomeAnexo,
          no_extensao: this[nomeAnexo].fileExtension,
          no_mime_type: this[nomeAnexo].fileType,
          no_arquivo: this[nomeAnexo].filename,
          arquivoCodificado: this[nomeAnexo].getFileEncodeBase64String(),
        });
      });
    },
    salvar() {
      const self = this;
      if (!self.$refs.form_recurso.validate()) {
        return false;
      }

      this.validarAnexos();

      this.loading = true;
      this.avaliarRecursoInscricao(self.formulario)
        .then(() => {
          self.recursoDialog = false;
        })
        .finally((response) => {
          this.loading = false;
          self.modalConfirmacao = false;
          this.isLoadingHistorico = true;
          this.obterHistoricoAvaliacao(this.formulario.co_recurso_inscricao);
          this.formulario.avaliador = response.avaliador;
        });
      return true;
    },
    editar() {
      this.formularioEditado.ds_parecer_justificativa = this.formularioEditado.ds_parecer_justificativa.trim();
      if (!this.formularioEditado.ds_parecer_justificativa) {
        return;
      }
      Object.assign(this.formulario, this.formularioEditado);
      this.abrirDialogo();
    },
    abrirDialogo() {
      const self = this;
      if (!self.$refs.form_recurso.validate()) {
        return false;
      }
      this.modalConfirmacao = true;
      return true;
    },
    abrirDialogoSelecaoAvaliador() {
      this.modalSelecaoAvaliador = true;
      return true;
    },
    abrirDialogoEntidade(entidade) {
      this.modalDialogoEntidade = true;
      return true;
    },
    abrirDialogoHistorico() {
      this.modalDialogoHistorico = true;
      return true;
    },
    abrirDialogoEditar() {
      this.formularioEditado.ds_parecer = this.formulario.ds_parecer;
      this.formularioEditado.st_parecer = this.formulario.st_parecer;
      this.modalDialogoEditar = true;
      return true;
    },
    fecharDialogo() {
      this.modalConfirmacao = false;
    },
    fecharDialogoSelecaoAvaliador() {
      this.modalSelecaoAvaliador = false;
    },
    fecharDialogoEntidade() {
      this.modalDialogoEntidade = false;
    },
    fecharDialogoEditar() {
      this.formularioEditado = {};
      this.modalDialogoEditar = false;
    },
    handleTabAction() {
      this.activeTab = !this.activeTab;
    },
    alterarAvaliador(avaliadorSelecionado) {
      if (this.formulario.avaliador && (this.formulario.avaliador.co_usuario == avaliadorSelecionado.co_usuario || !avaliadorSelecionado.co_usuario || avaliadorSelecionado.co_usuario == 0)) {
        this.fecharDialogoSelecaoAvaliador();
        return;
      }
      this.isLoadingSelecao = true;
      this.atualizarAvaliador(avaliadorSelecionado).finally(() => {
        this.formulario.avaliador = this.avaliadores.find(item => item.co_usuario === avaliadorSelecionado.co_usuario);
        this.isLoadingSelecao = false;
        this.isLoadingHistorico = true;
        this.obterHistoricoAvaliacao(this.formulario.co_recurso_inscricao);
        eventHub.$emit(
          'eventoSucesso',
          'Atualizado com sucesso! Um email será enviado para o avaliador.',
        );
        this.fecharDialogoSelecaoAvaliador();
      });
    },
    createRecursoPdf() {
      const pdf = new JsPdf();
      pdf.setFontSize(13);
      pdf.text('AVALIAÇÃO RECURSO DA INSCRIÇÃO', 60, 15);

      pdf.addImage(require('../../../assets/logo-cnpc-novo-site.png'), 'png', 9, 8, 45, 0);

      pdf.setFontSize(10);
      pdf.text('CNPJ:', 10, 30);
      pdf.cell(10, 32, 40, 10, this.formulario.nu_cnpj);

      pdf.text('Razão Social:', 50, 30);
      pdf.cell(50, 32, 150, 10, this.formulario.no_razao_social);


      pdf.text('CPF Representante:', 10, 50);
      pdf.cell(10, 52, 40, 10, this.formulario.nu_cpf);

      pdf.text('Nome Representante:', 50, 50);
      pdf.cell(50, 52, 150, 10, this.formulario.no_representante);


      pdf.text('Telefone Representante:', 10, 70);
      pdf.cell(10, 72, 40, 10, this.formulario.nu_telefone);

      pdf.text('Email Representante:', 50, 70);
      pdf.cell(50, 72, 150, 10, this.formulario.ds_email);


      pdf.text('Data Recurso:', 10, 90);
      pdf.cell(10, 92, 40, 10, this.$options.filters.formatDate(this.formulario.dh_cadastro));


      const tipoRecurso = this.formulario.co_fase === 4 ? 'Conselho de Cultura' : 'Organização ou entidade cultural';

      pdf.text('Tipo Recurso:', 50, 90);
      pdf.cell(50, 92, 150, 10, tipoRecurso);


      pdf.text('CPF Avaliador:', 10, 110);
      pdf.cell(10, 112, 40, 10, this.formulario.avaliador.nu_cpf);

      pdf.text('Nome Avaliador:', 50, 110);
      pdf.cell(50, 112, 150, 10, this.formulario.avaliador.no_nome);


      pdf.text('Descrição do Recurso:', 10, 130);
      pdf.cell(10, 132, 190, 70, this.formulario.ds_recurso);

      pdf.text('Parecer:', 10, 160 + 50);
      pdf.cell(10, 162 + 50, 190, 30, this.formulario.ds_parecer);

      const resultado = this.formularioEditado.st_parecer ? 'Recurso Deferido' : 'Recurso Indeferido';
      pdf.text('Avaliação:', 10, 160 + 50 + 40);
      pdf.cell(10, 162 + 50 + 40, 190, 10, resultado);

      pdf.text('Justificativa Edição do Recurso:', 10, 160 + 50 + 40 + 20);
      pdf.cell(10, 162 + 50 + 40 + 20, 190, 20, this.formulario.ds_parecer);

      pdf.save(`${this.formulario.nu_cnpj}.pdf`);
    },
  },
  mounted() {
    this.buscarPerfisAlteracao();
  },
};
</script>
